import { Navigate, Outlet, type RouteObject } from "react-router-dom";
import UserGroupManagement from "./adminOverview/UserGroupManagement.page";
import GruppeOverview from "./adminAssignment/GruppenOverview.page";

/**
 * Routes for the organization admin
 */
export const adminRoutes: RouteObject[] = [
	{
		element: <Outlet />,
		children: [
			{
				path: "user-group-management",
				element: <UserGroupManagement />,
			},
			{
				path: "dashboard",
				element: <GruppeOverview />,
			},
			{
				// Redirect old student-klausur-management route to consolidated klausur page
				path: "student-klausur-management",
				element: <Navigate to="/orga-admin/klausur" replace />,
			},
		],
	},
];
